export enum CanGraphMessages {
  title = "reports.canGraph.title",
  vehicle = "reports.canGraph.vehicle",
  day = "reports.canGraph.day",
  apply = "reports.canGraph.apply",
  loading = "reports.canGraph.loading",
  noDataTitle = "reports.canGraph.noDataTitle",
  noDataDescription = "reports.canGraph.noDataDescription",
  fields = "reports.canGraph.fields",
  fieldsCanGroup = "reports.canGraph.fieldsCanGroup",
  fieldsTrackerGroup = "reports.canGraph.fieldsTrackerGroup",
  selectAll = "reports.canGraph.selectAll",
  clearAll = "reports.canGraph.clearAll",
  zoomIn = "reports.canGraph.zoomIn",
  zoomOut = "reports.canGraph.zoomOut",
  resetZoom = "reports.canGraph.resetZoom",
  sourceLabel = "reports.canGraph.sourceLabel",
  sourceCache = "reports.canGraph.sourceCache",
  sourceData = "reports.canGraph.sourceData",
  sourceTooltipCache = "reports.canGraph.sourceTooltipCache",
  sourceTooltipData = "reports.canGraph.sourceTooltipData",
  pointsCount = "reports.canGraph.pointsCount",
  devId = "reports.canGraph.devId",
  invalidDateRange = "reports.canGraph.invalidDateRange",
  vehicleWithoutHardware = "reports.canGraph.vehicleWithoutHardware",
  success = "reports.canGraph.success",
  error = "reports.canGraph.error",
  fieldCanSpd = "reports.canGraph.fields.canSpd",
  fieldCanEngineRpm = "reports.canGraph.fields.canEngineRpm",
  fieldCanEngineCoolantTemperature = "reports.canGraph.fields.canEngineCoolantTemperature",
  fieldCanFuelLevelSmoothed = "reports.canGraph.fields.canFuelLevelSmoothed",
  fieldCanFuelConsumption = "reports.canGraph.fields.canFuelConsumption",
  fieldCanTotalFuelUsed = "reports.canGraph.fields.canTotalFuelUsed",
  fieldCanTotalFuelUsedCounted = "reports.canGraph.fields.canTotalFuelUsedCounted",
  fieldCanTotalIdleFuelUsed = "reports.canGraph.fields.canTotalIdleFuelUsed",
  fieldCanTotalEngineHours = "reports.canGraph.fields.canTotalEngineHours",
  fieldCanTotalEngineHoursCounted = "reports.canGraph.fields.canTotalEngineHoursCounted",
  fieldCanTotalDrivingTime = "reports.canGraph.fields.canTotalDrivingTime",
  fieldCanOdometer = "reports.canGraph.fields.canOdometer",
  fieldCanIgn = "reports.canGraph.fields.canIgn",
  fieldCanGcvw = "reports.canGraph.fields.canGcvw",
  fieldSpd = "reports.canGraph.fields.spd",
  fieldDist = "reports.canGraph.fields.dist",
  fieldHMeter = "reports.canGraph.fields.hMeter",
  fieldPwrVolt = "reports.canGraph.fields.pwrVolt",
}

export type TranslationCanGraphMessages = {
  [CanGraphMessages.title]: string,
  [CanGraphMessages.vehicle]: string,
  [CanGraphMessages.day]: string,
  [CanGraphMessages.apply]: string,
  [CanGraphMessages.loading]: string,
  [CanGraphMessages.noDataTitle]: string,
  [CanGraphMessages.noDataDescription]: string,
  [CanGraphMessages.fields]: string,
  [CanGraphMessages.fieldsCanGroup]: string,
  [CanGraphMessages.fieldsTrackerGroup]: string,
  [CanGraphMessages.selectAll]: string,
  [CanGraphMessages.clearAll]: string,
  [CanGraphMessages.zoomIn]: string,
  [CanGraphMessages.zoomOut]: string,
  [CanGraphMessages.resetZoom]: string,
  [CanGraphMessages.sourceLabel]: string,
  [CanGraphMessages.sourceCache]: string,
  [CanGraphMessages.sourceData]: string,
  [CanGraphMessages.sourceTooltipCache]: string,
  [CanGraphMessages.sourceTooltipData]: string,
  [CanGraphMessages.pointsCount]: string,
  [CanGraphMessages.devId]: string,
  [CanGraphMessages.invalidDateRange]: string,
  [CanGraphMessages.vehicleWithoutHardware]: string,
  [CanGraphMessages.success]: string,
  [CanGraphMessages.error]: string,
  [CanGraphMessages.fieldCanSpd]: string,
  [CanGraphMessages.fieldCanEngineRpm]: string,
  [CanGraphMessages.fieldCanEngineCoolantTemperature]: string,
  [CanGraphMessages.fieldCanFuelLevelSmoothed]: string,
  [CanGraphMessages.fieldCanFuelConsumption]: string,
  [CanGraphMessages.fieldCanTotalFuelUsed]: string,
  [CanGraphMessages.fieldCanTotalFuelUsedCounted]: string,
  [CanGraphMessages.fieldCanTotalIdleFuelUsed]: string,
  [CanGraphMessages.fieldCanTotalEngineHours]: string,
  [CanGraphMessages.fieldCanTotalEngineHoursCounted]: string,
  [CanGraphMessages.fieldCanTotalDrivingTime]: string,
  [CanGraphMessages.fieldCanOdometer]: string,
  [CanGraphMessages.fieldCanIgn]: string,
  [CanGraphMessages.fieldCanGcvw]: string,
  [CanGraphMessages.fieldSpd]: string,
  [CanGraphMessages.fieldDist]: string,
  [CanGraphMessages.fieldHMeter]: string,
  [CanGraphMessages.fieldPwrVolt]: string,
};
